module.exports = __webpack_public_path__ + "img/it.7e3ffd8f.svg";